import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllHookloaderDeployedReport } from "../../../Apis/TransferStationReport/hookloaderReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1, getToken } from "../../../Common/helper/helpar";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { exportToPDF } from "../../../../utils/exportToPDF";
import SmallLoader from "../../../../Hooks/SmallLoader";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";

const DeployedHookloaderReport = ({ t }) => {
  const headers = [
    "hookloaderUid",
    "vehicleNumber",
    "vehicleType",
    "ownerType",
    "tsincharge",
    "tsname",
    "deploymentDate",
    "latitude",
    "longitude",
    "address",
    "image",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [IsExcelDowanload, setIsExcelDowanload] = useState(false);
  const isProd = isGHMC();

  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate, vehicleNumber);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate, vehicleNumber) => {
    try {
      setIsLoading(true);
      const response = await AllHookloaderDeployedReport(
        startDate,
        endDate,
        vehicleNumber,
      );
      const formattedData = response.data.map((item) => ({
        ...item,
        hookloaderUid: item.hookloaderUuid || "N/A",
        image: item.hookloaderImageUrl || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        tsincharge: item.transferStationInchargeName || "N/A",
        tsname: item.transferStationName || "N/A",
        latitude: item.scannedLatitude || "N/A",
        longitude: item.scannedLongitude || "N/A",
        address: item.address || "N/A",
      }));
      setAllTripsTonnage(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, vehicleNumber);
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Deployed Hookloader Transaction Report  ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add Date Range
    // worksheet.addRow(["", "", dateRange, ""]);
    // worksheet.mergeCells(2, 2, 2, 8);
    // worksheet.getCell(2, 2).value = dateRange;
    // worksheet.getCell(2, 2).font = boldFont;
    // worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(3, 2, 3, 8);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 8; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Hookloader UID",
      "Vehicle Number",
      "Vehicle Type",
      "Owner Type",
      "TS Incharge",
      "TS Name",
      "Deployment Date",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 11) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.hookloaderUuid ?? "N/A",
          item.vehicleNumber ?? "N/A",
          item.vehicleTypeName ?? "N/A",
          item.ownerTypeName ?? "N/A",
          item.transferStationInchargeName ?? "N/A",
          item.transferStationName ?? "N/A",
          item.deploymentDate ?? "N/A",
          item.scannedLatitude ?? "N/A",
          item.scannedLongitude ?? "N/A",
          item.address ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 11) {
            cell.alignment = {
              horizontal: "left",
              vertical: "middle",
              wrapText: true,
            };
          } else {
            cell.alignment = {
              horizontal: "center",
              vertical: "middle",
              wrapText: true,
            };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DeployedHookloaderTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const dowanloadExcel = async () => {
    setIsExcelDowanload(true);
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}RawReport/GetAllDeployedHookLoadersTransactionExcelSheet`,
        {
          params: {      
           startDate,
           endDate,
            VehicleNumber: vehicleNumber,
          },
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
          responseType: "blob", // 🔥 VERY IMPORTANT
        },
      );

      // ✅ Create downloadable file
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Deployed Hookloader Transaction Report.xlsx"; // or backend filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed", error);
    } finally {
      setIsExcelDowanload(false);
    }
  };
  const exportPdf = async () => {

    await exportToPDF({
      fileName: "Deployed_Hookloader_Transaction_Report",
      title: "Deployed Hookloader Transaction Report",
      generatedOnText: `Report on: ${generationTime}, ${getCurrentDateTime1()}`,
      data: getAllTripsTonnage,
      landscape: true,

      columns: [
        {
          header: "S.No",
          accessor: (_row, index) => index + 1,
          width: 10,
        },
        {
          header: "Hookloader UID",
          accessor: row => row.hookloaderUuid ?? "N/A",
          width: 30,
        },
        {
          header: "Vehicle Number",
          accessor: row => row.vehicleNumber ?? "N/A",
          width: 25,
        },
        {
          header: "Vehicle Type",
          accessor: row => row.vehicleTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "Owner Type",
          accessor: row => row.ownerTypeName ?? "N/A",
          width: 25,
        },
        {
          header: "TS Incharge",
          accessor: row => row.transferStationInchargeName ?? "N/A",
          width: 30,
        },
        {
          header: "TS Name",
          accessor: row => row.transferStationName ?? "N/A",
          width: 30,
        },
        {
          header: "Deployment Date",
          accessor: row =>
            formatDateForDisplay(row.deploymentDate) ?? "N/A",
          width: 28,
        },
        {
          header: "Latitude",
          accessor: row => row.scannedLatitude ?? "N/A",
          width: 22,
        },
        {
          header: "Longitude",
          accessor: row => row.scannedLongitude ?? "N/A",
          width: 22,
        },
        {
          header: "Address",
          accessor: row => row.address ?? "N/A",
          width: 60,
        },
        {
          header: "Image",
          accessor: r => r.hookloaderImageUrl,
          isImage: true,
          width: 20,
        },

      ],
    });

  }
  return (
    <>
      {isLoading ? (
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                {t("Deployed Hookloader Transaction Report")} (
                {formatDateForDisplay(startDate)} to{" "}
                {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row" style={{ textAlign: "left" }}>
                      <div className="col-md-3">
                        <label>From Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="FromDate"
                          style={inputStyle}
                          className="form-control"
                          value={startDate}
                          max={endDate ? endDate : getCurrentDateTime()}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>To Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="ToDate"
                          style={inputStyle}
                          value={endDate}
                          className="form-control"
                          min={startDate}
                          max={getCurrentDateTime()}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Vehicle Number</label>
                        <input
                          type="text"
                          name="vehicleTypeCode"
                          style={inputStyle}
                          placeholder="Vehicle Number"
                          className="form-control"
                          value={vehicleNumber}
                          onChange={(e) => {
                            setVehicleNumber(
                              e.target.value.replace(/\s+/g, ""),
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <div className="d-flex justify-content-between align-items-end">
                          <button
                            type="submit"
                            className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-excel ms-auto mt-4"
                            onClick={dowanloadExcel}
                          >
                            {IsExcelDowanload ? <SmallLoader /> : <span>
                              <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                              Excel
                            </span>}
                          </button>

                          <button
                            className="btn btn-excel ms-auto mt-4"
                            onClick={exportPdf}
                          >
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                            Pdf
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="mt-3">
                  <TableComponent isLoading={isLoading}
                    DataFetchURL={getAllTripsTonnage}
                    headers={headers}
                    imgField="image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  borderRadius: "5px",
  color: "#fff",
};

export default withTranslation()(DeployedHookloaderReport);
